import React, {Component} from 'react';
import {observer} from 'mobx-react';
import {SortableContainer, SortableElement, SortableHandle} from 'react-sortable-hoc';

import PseudoLinkBox from 'lib/struct/pseudo_link/PseudoLinkBox';
import InputText from 'lib/struct/form/InputText';
import Icon from 'lib/struct/icon/Icon';
import IconBox from 'lib/struct/icon/IconBox';

import * as MarkupTemplateId from 'settings/constant/MarkupTemplateId';

import ProductFinderInput from './ProductFinderInput';

import styles from './GroupSettingsForm.less';

const DragHandle = SortableHandle(() => (
	<span className={styles['group-form__drag-handle']}>
		<Icon name='sort'/>
	</span>
));

@observer class GroupProductElement extends Component {
	render() {
		/** @type {ProductGroupsSettingsContext} */
		const context = this.props.context;
		const product = context.product;

		/** @type {ProductGroup} */
		const product_group = this.props.product_group;
		/** @type {GroupProduct} */
		const group_product = this.props.group_product;

		return (
			<tr key={group_product.product_id}>
				<td className={styles['group-form__sort-column']}>
					<DragHandle/>
				</td>
				<td className={styles['group-form__name-column']}>
					{group_product.product_name}

					{
						group_product.product_id !== product.id ? (
							<PseudoLinkBox
								onClick={() => product_group.removeGroupProduct(group_product)}
								className={styles['group-form__remove-product-link']}
							>
								<Icon name='no' />
							</PseudoLinkBox>
						) : (null)
					}
				</td>
				<td className={styles['group-form__label-column']}>
					{
						product_group.group.markup_template_id === MarkupTemplateId.SIMPLE_GROUP ? (
							<InputText
								className={styles['text-input']}
								onChange={e => group_product.label = e.target.value}
								value={group_product.label}
							/>
						) : (null)
					}
				</td>
				<td className={styles['group-form__primary-column']}>
					{
						product_group.group.show_on_primary_product_only ? (
							<input
								type='radio'
								value={group_product.product_id}
								onChange={e => product_group.setGroupProductPrimary(group_product, e.target.checked)}
								checked={group_product.is_primary}
							/>
						) : (null)
					}
				</td>
			</tr>
		);
	}
}

const GroupProductSortableElement = SortableElement(GroupProductElement);

@observer class GroupProductsContainer extends Component {
	render() {
		/** @type {ProductGroupsSettingsContext} */
		const context = this.props.context;

		/** @type {ProductGroup} */
		const product_group = this.props.product_group;

		return (
			<table className={`table zebra ${styles['group-form__table']}`}>
				<thead>
				<tr>
					<th className={styles['group-form__sort-column']} />
					<th className={styles['group-form__name-column']}>Название товара</th>
					<th className={styles['group-form__label-column']}>
						{
							product_group.group.markup_template_id === MarkupTemplateId.SIMPLE_GROUP ? (
								'Название ссылки'
							) : (null)
						}
					</th>
					<th className={styles['group-form__primary-column']}>
						{
							product_group.group.show_on_primary_product_only ? (
								'Основной товар'
							) : (null)
						}
					</th>
				</tr>
				</thead>
				<tbody>
				{
					product_group.products.map((group_product, index) => (
						<GroupProductSortableElement
							key={group_product._key}
							index={index}
							context={context}
							product_group={product_group}
							group_product={group_product}
						/>
					))
				}
				</tbody>
			</table>
		);
	}
}

const GroupProductsSortableContainer = SortableContainer(GroupProductsContainer);

@observer export default class GroupSettingsForm extends Component {
	render() {
		/** @type {ProductGroupsSettingsContext} */
		const context = this.props.context;
		/** @type {ProductGroup} */
		const product_group = this.props.product_group;

		return (
			<div className={styles['group-form__block']}>
				<div className={styles['group-form__group-header-block']}>
					<span className={styles['group-form__group-header-label']}>{product_group.group.name}</span>

					<PseudoLinkBox
						onClick={() => context.removeProductGroup(product_group)}
						className={styles['group-form__remove-group-link']}
					>
						<Icon name='no' />
					</PseudoLinkBox>
				</div>

				<GroupProductsSortableContainer
					context={context}
					product_group={product_group}
					helperClass={styles['group-form__sortable-container-helper']}
					onSortEnd={({oldIndex, newIndex}) => {
						product_group.changeProductsOrder(oldIndex, newIndex);
						$('body').removeClass(styles['sortable-container__body-helper'])
					}}
					onSortStart={() => {
						$('body').addClass(styles['sortable-container__body-helper']);
					}}

					axis='y'
					lockAxis='y'
					useDragHandle
					lockToContainerEdges
				/>

				<div className={styles['group-form__product-finder-block']}>
					<IconBox
						icon={<Icon name='add' />}
					>
						<ProductFinderInput
							onSelect={item => product_group.addGroupProductByItem(item)}
							except_ids={[context.product.id, ...product_group.products.map(p => p.product_id)]}
						/>
					</IconBox>
				</div>
			</div>
		);
	}
}